import loadable from '@loadable/component';
import LoadingComponent from 'components/Loaders/LoadingComponent';

const UnitizerInformedLoadable = loadable(
  () => import(/* webpackChunkName: 'admin-UnitizerInformed' */ './UnitizerInformed'),
  {
    fallback: <LoadingComponent />,
  }
);

export default UnitizerInformedLoadable;
